import { render } from "./KuponJajan.vue?vue&type=template&id=863e1512"
import script from "./KuponJajan.vue?vue&type=script&lang=js"
export * from "./KuponJajan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__